// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-category-textblock',
    // #endregion
    // #region Properties
    props: {
        texte: {
            type: Object,
            required: false,
            default: {}
        },
        location: {
            type: String,
            required: false,
            default: 'top'
        },
    },
    // #endregion
});
// #endregion
